import { createErrorTransformer } from 'store/queries/utils.ts'
import { Flow } from 'types/logging.ts'
import { boltBackend } from '../index.ts'
import {
  GetCustomerAccountingPathParameters,
  GetCustomerAccountingResponseBody,
  GetCustomerPaymentPlanResponseBody,
  GetCustomerPaymentPlanPathParameters
} from '@boltenergy-be/shared'

export const customersBoltBackend = boltBackend.injectEndpoints({
  endpoints: (builder) => ({
    // GET CUSTOMER ACCOUNTING
    getCustomerAccounting: builder.query<GetCustomerAccountingResponseBody, GetCustomerAccountingPathParameters>({
      query: ({ customerNumber }) => ({
        url: `/resources/customers/${customerNumber}/accounting`
      }),
      transformResponse: ({ data }) => {
        return data
      },
      transformErrorResponse: createErrorTransformer(`[${Flow.CUSTOMERS}:getCustomerAccounting]`)
    }),

    // GET CUSTOMER PAYMENT PLAN
    getCustomerPaymentPlan: builder.query<GetCustomerPaymentPlanResponseBody, GetCustomerPaymentPlanPathParameters>({
      query: ({ customerNumber }) => ({
        url: `/resources/customers/${customerNumber}/payment-plan`
      }),
      transformResponse: ({ data }) => {
        return data
      },
      transformErrorResponse: createErrorTransformer(`[${Flow.CUSTOMERS}:getCustomerPaymentPlan]`)
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCustomerAccountingQuery, useGetCustomerPaymentPlanQuery } = customersBoltBackend
